import _export from '../internals/export.js';

var $ = _export; // `Reflect.has` method
// https://tc39.es/ecma262/#sec-reflect.has

$({
  target: 'Reflect',
  stat: true
}, {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});
